import { render, staticRenderFns } from "./SelWorkerList.vue?vue&type=template&id=b8dc0bb2&"
import script from "./SelWorkerList.vue?vue&type=script&lang=js&"
export * from "./SelWorkerList.vue?vue&type=script&lang=js&"
import style0 from "./SelWorkerList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports